var exports = {
  "image": "xfd349460--ef32f3--image",
  "image--cover": "xfd349460--ef32f3--image--cover",
  "image-container": "xfd349460--ef32f3--image-container",
  "image--contain": "xfd349460--ef32f3--image--contain",
};

module.exports = exports;
